import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'

const LowBox = ({id, quantity}) => {
  return (
    <div 
      style={{borderRadius: "15px", minWidth:"200px", maxWidth: "260px", flexGrow: "1"}} 
      className="m-2 text-dark p-4 d-flex flex-column rounded shadow"
    >
      <p className='fs-2'>Item Id: {id}</p>
      <div style={{padding:"1px"}} className="bg-dark w-100 mb-3"></div>
      <p>Inventory: <span className='fw-bold'>{quantity}</span></p>
      <p className=''>Added Last Quarter: <span className='fw-bold'>{Math.ceil(quantity /20) + Math.ceil(Math.random()*20)}</span></p>
      <div style={{padding:"1px"}} className="bg-dark w-100 mb-3"></div>
      <div className='d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon className='fs-2' icon={faClock} /> 
        <p>April 21  4.15 am</p>

      </div>
      
    </div>
  )
}

export default LowBox